import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import API from '../canvas-api';
import { handleGenericError } from '../common';
import { actions } from '../../reducers/printers/printers';

export default function* queryPrinterTags(action) {
  const { queryString } = action.payload;
  try {
    const response = yield call(API, {
      path: `printers/tags/?search=${queryString}`,
    });

    if (response === null) return;

    const { tags } = response;

    yield put(actions.queryPrinterTagsSuccess(tags));
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
